import { FinalStandingsTableColumns } from "~pages/FinalStandings/enums/finalStandingsTableColumns.ts";
import { FixturesFilterTypes } from "~pages/Fixtures/FixtureListPage/types";
import { FixtureTableColumns } from "~pages/Fixtures/FixtureListPage/types/fixtureColumnsEnum.ts";
import type { DataTableColumnGroupDefinition } from "~types/dataTableColumnGroupDefinition.ts";
import type { UiConfiguration } from "~types/uiConfiguration.ts";
import { defaultUiConfig } from "./defaultsUi";

const finalStandingsTableColumnsArray: Array<DataTableColumnGroupDefinition> = [
  {
    columnChooserTitleIntlKey: "finalStandings.table.column.chooser.title.details",
    columns: [
      { key: FinalStandingsTableColumns.Person, defaultInColumnChooser: true },
      { key: FinalStandingsTableColumns.PersonId },
      { key: FinalStandingsTableColumns.Position, defaultInColumnChooser: true },
      { key: FinalStandingsTableColumns.ResultPlace, defaultInColumnChooser: true },
      { key: FinalStandingsTableColumns.Points, defaultInColumnChooser: true },
      { key: FinalStandingsTableColumns.ExternalId },
      { key: FinalStandingsTableColumns.PlacingId },
      { key: FinalStandingsTableColumns.PrizeMoney, defaultInColumnChooser: true },
    ],
  },
];

export const fixtureTableColumnsArray: Array<DataTableColumnGroupDefinition> = [
  {
    columnChooserTitleIntlKey: "fixtures.table.column.chooser.title.details",
    columns: [
      { key: FixtureTableColumns.FixtureId },
      { key: FixtureTableColumns.ExternalId },
      { key: FixtureTableColumns.RoundNumber, defaultInColumnChooser: true },
      { key: FixtureTableColumns.Result, defaultInColumnChooser: true },
      { key: FixtureTableColumns.FixtureNumber, defaultInColumnChooser: true },
      { key: FixtureTableColumns.NameLocal },
      { key: FixtureTableColumns.NameLatin },
      { key: FixtureTableColumns.VenueId, defaultInColumnChooser: true },
      { key: FixtureTableColumns.StartDate, defaultInColumnChooser: true },
      { key: FixtureTableColumns.StartTime, defaultInColumnChooser: true },
      { key: FixtureTableColumns.FixtureType, defaultInColumnChooser: true },
      { key: FixtureTableColumns.Status, defaultInColumnChooser: true },
      { key: FixtureTableColumns.Stage, defaultInColumnChooser: true },
      { key: FixtureTableColumns.StageCode },
      { key: FixtureTableColumns.Pool, defaultInColumnChooser: true },
      { key: FixtureTableColumns.PoolCode },
      { key: FixtureTableColumns.Series },
      { key: FixtureTableColumns.SeriesCode },
      { key: FixtureTableColumns.Added },
      { key: FixtureTableColumns.Attendance },
      { key: FixtureTableColumns.Discipline },
      { key: FixtureTableColumns.StartTimeActualUtc },
      { key: FixtureTableColumns.EndTimeActualUtc },
      { key: FixtureTableColumns.FixtureProfile },
      { key: FixtureTableColumns.ProfileId },
      { key: FixtureTableColumns.InternationalReference },
      { key: FixtureTableColumns.Round },
      { key: FixtureTableColumns.RoundCode },
      { key: FixtureTableColumns.SeriesFixtureNumber },
      { key: FixtureTableColumns.TimesUnconfirmed },
      { key: FixtureTableColumns.StartTimeUtc },
      { key: FixtureTableColumns.HomeParticipants, defaultInColumnChooser: true },
      { key: FixtureTableColumns.AwayParticipants, defaultInColumnChooser: true },
    ],
  },
];

export const tennisUi: UiConfiguration = {
  ...defaultUiConfig,
  pages: {
    ...defaultUiConfig.pages,
    fixtures: {
      listPage: {
        columnsConfig: fixtureTableColumnsArray,
        filtersConfig: [
          { filterKey: FixturesFilterTypes.RoundNumber },
          { filterKey: FixturesFilterTypes.Participants },
          { filterKey: FixturesFilterTypes.Venues },
          { filterKey: FixturesFilterTypes.FixtureStatuses },
          { filterKey: FixturesFilterTypes.Pools },
          { filterKey: FixturesFilterTypes.Stages },
          { filterKey: FixturesFilterTypes.DateRange },
        ],
        importConfig: {
          titleIntlKey: "import.modal.title.fixtures",
          descriptionIntlKey: "import.modal.text.fixtures",
        },
      },
    },
    finalStandings: {
      listPage: {
        columnsConfig: finalStandingsTableColumnsArray,
      },
    },
  },
};
